import React, { useState, useEffect, useRef, useMemo } from "react";
import { loadModules } from "esri-loader";
import MasterPlanMap from "../../componets/MasterPlanMap";
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { useDispatch, useSelector } from "react-redux";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import * as XLSX from 'xlsx';
import { setIsBufferWidth, setIsSidebar } from "../../store/slice/currentStageSlice";
import { useNavigate } from "react-router-dom";
import "@arcgis/core/assets/esri/themes/light/main.css";
import './SCADAHomeLayout.css';

// import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";

import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";



const MASTER_PLAN_URL =
    "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";
const PROPERTY_URL =
    "https://urbangis.mp.gov.in/server/rest/services/Hosted/property_info_209/FeatureServer/1";
const ADMIN_LAYER_URL =
    "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";



function SCADAHome({
    isWidth, isByDefaultActive, isScreenSize
}) {

    // BHUPEN_D CODE 
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [districtCode, setDistrictCode] = useState("");
    // BHUPEN_D CODE 

    // BHUPEN_ULB
    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState("");
    const [ulbCode, setUlbCode] = useState("");
    // BHUPEN_ULB


    // BHUPEN_TABLE
    const [LiveData, setLiveData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [activeLayer, setActiveLayer] = useState("sewer"); // default active
    const [tableData, setTableData] = React.useState([]);
    const [distictList, setdistictList] = React.useState([]);
    const [tableData2, setTableData2] = React.useState([]);
    // BHUPEN_TABLE
    // const [townOptions, setTownOptions] = useState([]);
    // const [landUseOptions, setLandUseOptions] = useState([]);
    const [selectedTown, setSelectedTown] = useState("");
    const [selectedLandUse, setSelectedLandUse] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [propertyFeatures, setPropertyFeatures] = useState([]);

    const [filteredCount, setFilteredCount] = useState({ title: "Property Type", value: 0 });
    const { isTheme, isBufferWidth, isToolHeight } = useSelector((state) => state.currentStage)

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [filteredPropertyData, setFilteredPropertyData] = useState([]);
    const [paginatedAllData, setPaginatedAllData] = useState([]); // New state for paginated 'All' data
    const [isTableView, setIsTableView] = useState(false);
    const [isTableMaximized, setIsTableMaximized] = useState(false);
    const [isAllData, setIsAllData] = useState([]);
    const [activeSelect, setActiveSelect] = useState(""); // Default to 'filter'
    const [isRelationId, setIsRelationId] = useState(); // Default to 'filter'
    const [view, setView] = useState(null);
    const [paginationTotal, setPaginationTotal] = useState({});
    const [paginationFilter, setPaginationFilter] = useState({});
    const legendWidgetRef = useRef(null);


    const viewRef = useRef(null);
    const mapRef = useRef(null);
    const highlightLayerRef = useRef(null);
    const masterSubRef = useRef(null);
    const propertyLayerRef = useRef(null);
    const propertyLayerViewRef = useRef(null);

    const [towns, setTowns] = useState([]);
    const [townToUlb, setTownToUlb] = useState({});
    const [landUses, setLandUses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tableFields, setTableFields] = useState([]);
    const [pagination, setPagination] = useState({ page: 0, totalPages: 0 });
    const unionGeomRef = useRef(null);


    const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
    const { currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
    const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
    const dispatch = useDispatch();
    const authData = useSelector(state => state.authToken.authData);

    console.log("authData", authData)
    const layerRef = useRef(null);
    const [map, setMap] = useState(null);
    const mapDiv = useRef(null);
    // const townOptions = towns.map((town) => ({ label: town, value: town }));
    // code for add new zoom method on UL
    const buildFilter = (dist_cd, ulb_cd, wardno) => {
        const conditions = [];
        if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
        if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
        if (wardno) conditions.push(`wardno = '${wardno}'`);
        return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
    };



    useEffect(() => {
        if (authData) {
            if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                setSelectedTown(authData.UlbName);
                setTownToUlb({ [authData.UlbName]: authData.Ulb_Code });
                //  populateLandUseByTown(authData.UlbName)

            } else {
                // populateTowns();
            }
        }
    }, [authData]);


    // 13SEP code for add new zoom method  on ULB


    const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

    useEffect(() => {
        if (!view) return;
        view.graphics.removeAll();
        handleTabClick();

    }, [view, authData]);

    // code for ALL LAYERS

    const handleTabClick = (key, wardNo, distCd) => {
        if (!view) return;

        // 🔹 Clear graphics
        view.graphics.removeAll();

        // 🔹 Remove old layers
        if (layerRef.current?.length) {
            layerRef.current.forEach(layer => view.map.remove(layer));
        }

        // 🔹 Build filter
        let filterExpr;
        filterExpr = buildFilter(distCd, key, wardNo);

        setIsTableView(true);

        /* ================= ADMIN LAYER ================= */
        const adminLayer = new MapImageLayer({
            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer",
            sublayers: [
                { id: 1, visible: true },
                { id: 3, visible: true }
            ]
        });

        /* ================= MAP IMAGE (RAW) ================= */
        const ws_intersect_poiLayer = new MapImageLayer({
            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/scada_device_location/MapServer",
            sublayers: [{ id: 1, visible: false }] // hide raw points
        });

        ws_intersect_poiLayer.when(() => {
            const sub = ws_intersect_poiLayer.findSublayerById(1);
            if (sub) sub.definitionExpression = filterExpr;
        });



        /* ================= LIVE DATA LAYER ================= */
        const LiveDATALayer = new MapImageLayer({
            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/scada_device_data/MapServer",
            sublayers: [{ id: 1, visible: true }]
        });

        LiveDATALayer.when(() => {
            const sub = LiveDATALayer.findSublayerById(1);
            if (sub) sub.definitionExpression = filterExpr;
        });

        /* ================= ADD TO MAP ================= */
        view.map.addMany([
            adminLayer,
            ws_intersect_poiLayer,
            LiveDATALayer
        ]);

        /* ================= COUNT ONLINE / OFFLINE ================= */

        // alert(onlineCount);


        /* ================= SAVE REFS ================= */
        layerRef.current = [
            adminLayer,
            ws_intersect_poiLayer,
            LiveDATALayer
        ];
    };



    // CODE FOR RIGHT SIDE LIST 



    // CODE FOR RIGHT SIDE LIST 
    const handleTabClickForFeature = async (ulbKey, distCd) => {
        try {

            //  alert();
            // 1️⃣ Build where clause
            let whereClause = "1=1";

            if (distCd) {
                whereClause += ` AND dist_cd = '${distCd}'`;
            }

            if (ulbKey) {
                whereClause += ` AND ulb_cd = '${ulbKey}'`;
            }

            // if (wardNo) {
            //     whereClause += ` AND wardno = '${wardNo}'`;
            // }

            // 2️⃣ Query params
            const params = new URLSearchParams({
                where: whereClause,
                outFields:
                    "siteid,device_id,site_name,station_name,st_name,latitude,longitude,ulb_cd,dist_cd,wardno",
                orderByFields: "siteid ASC",
                f: "json",
            });

            const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/scada_device_location/MapServer/1/query?${params.toString()}`;

            const res = await fetch(url);
            const data = await res.json();

            const features = data.features || [];

            // 3️⃣ DISTINCT by siteid (client-side)
            const uniqueFeatures = Object.values(
                features.reduce((acc, item) => {
                    const siteid = item.attributes.siteid;
                    if (!acc[siteid]) {
                        acc[siteid] = item;
                    }
                    return acc;
                }, {})
            );

            // 4️⃣ Map rows
            const rows = uniqueFeatures.map((item, index) => {
                const a = item.attributes;

                return {
                    sno: index + 1,
                    siteid: a.siteid,
                    device_id: a.device_id,
                    site_name: a.site_name,
                    station_name: a.station_name,
                    st_name: a.st_name,
                    latitude: a.latitude,
                    longitude: a.longitude,
                    ulb_cd: a.ulb_cd,
                    dist_cd: a.dist_cd,
                    wardno: a.wardno,
                };
            });

            // 5️⃣ Set state
            setdistictList(rows);
            setTotalCount(rows.length); // ✅ correct count
            handleTabClickForFeature2();

        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const handleTabClickForFeature2 = async (ulbKey, distCd) => {
        try {
            const featureLayer = new FeatureLayer({
                url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/ws_intersect_poi/FeatureServer/1",
                outFields: ["*"]
            });

            await featureLayer.load();

            const query = featureLayer.createQuery();

            // ✅ Build dynamic filter
            let whereClause = "1=1";

            if (distCd) {
                whereClause += ` AND dist_cd = '${distCd}'`;
            }

            if (ulbKey) {
                whereClause += ` AND ulb_cd = '${ulbKey}'`;
            }

            // if (wardNo) {
            //     whereClause += ` AND wardno = '${wardNo}'`;
            // }

            query.where = whereClause;

            query.groupByFieldsForStatistics = [
                "dist_cd",
                "dist_nm",
                "ulb_cd",
                "ulb_nm"
            ];

            query.outStatistics = [
                {
                    statisticType: "count",
                    onStatisticField: "ulb_cd",
                    outStatisticFieldName: "ulb_count"
                }
            ];

            query.returnGeometry = false;

            const result = await featureLayer.queryFeatures(query);

            const groupedData = result.features.map(f => f.attributes);

            // Totals
            const totalULB = groupedData.length;
            const totalCount = groupedData.reduce(
                (sum, row) => sum + (row.ulb_count || 0),
                0
            );

            setTableData(groupedData);
            // setTotalULB(totalULB);
            // setTotalCount(totalCount);

            //setTableData2("");

        } catch (err) {
            console.error("Grouped Query Error:", err);
        }
    };





    useEffect(() => {

        if (!mapDiv.current) return;

        const mapInstance = new Map({
            basemap: "topo-vector"  // Use your desired basemap
        });

        const mapView = new MapView({
            container: mapDiv.current,  // The div where the map will render
            map: mapInstance,
            center: [77.4126, 23.2599],
            zoom: 5,
            ui: { components: ["attribution"] }
        });

        // Optionally, add a default layer
        const baseLayer = new MapImageLayer({
            url: mainLayerUrl,
            sublayers: []  // No initial sublayers
        });
        mapInstance.add(baseLayer);
        layerRef.current = baseLayer;

        setMap(mapInstance);    // Set the map reference
        setView(mapView);
        //  AdminLayer(0);    // Set the view reference


        // MAP LAYER LIST  Widget 

        mapView.ui.add(new Home({ view: mapView }), "top-left");
        mapView.ui.add(new Zoom({ view: mapView }), "top-left");
        mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
        mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");
        mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");

        mapView.when(() => {
            const printWidget = new Print({
                view: mapView,
                printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
            });

            const expandPrint = new Expand({
                view: mapView,
                content: printWidget
            });

            mapView.ui.add(expandPrint, "top-left");

        });

        return () => mapView.destroy();


        // end useEffect
    }, []);



    useEffect(() => {
        if (selectedLandUse && !loading || authData?.UserType === "districtuser" || authData?.UserType === "User") {
            //    runIntersect();
        } else if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
            //  runIntersect();
        }
    }, [selectedLandUse, selectedType, authData]);


    // my code




    const stats = [
        {
            value: totalCount ?? "-",
            title: `Property within Master Plan ${selectedLandUse || ""} Land Use`
        },
        {
            value: filteredCount && typeof filteredCount === "object" ? filteredCount.value : filteredCount ?? "-",
            title: filteredCount && typeof filteredCount === "object" ? filteredCount.title : "Filtered Properties"
        }
    ];


    const getTableColumns = () => {
        const dataToUse = activeSelect === "total" ? paginatedAllData : filteredPropertyData;
        if (!dataToUse || dataToUse.length === 0) return [];

        const firstFeatureAttributes = dataToUse[0];

        const hiddenKeys = [
            "objectid", "divisionname", "districtname", "dist_cd", "div_cd", "parcelno", "wardno",
            "electricity_id", "globalid", "shape", "shape_length", "shape_area", "ihtoiletk", "ihtoiletyn",
            "wstyofusedetails", "propertyno", "ulbtype", "photolink", "isuseres", "swmd2d", "swmd2dby",
            "swmd2ddetails", "remark", "singlepage", "wssldia", "wsmunconn", "wsconnno", "wsconncount",
            "vlandarea", "ulbname", "ulb_cd", "situationdetails", "taxzonename_e", "constructionyear",
            "relation_id", "shape__length", "shape__area"
        ];

        return Object.keys(firstFeatureAttributes)
            .filter(key => !hiddenKeys.includes(key.toLowerCase()))
            .map(key => ({
                field: key,
                header: key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())
            }));
    };


    const columns = getTableColumns();

    const toggleTableMaximize = () => {
        setIsTableMaximized(!isTableMaximized);
    };

    const handleNotificationClick = (rowId) => {

        setIsRelationId(rowId?.relation_id)
        handleRowClick(rowId?.relation_id)

    };

    //Code for 17sep 


    const ZOOMTOProperty = async (relationId) => {
        const layer = new FeatureLayer({ url: PROPERTY_URL });
        const query = new Query({
            where: `relation_id='${relationId}'`,
            returnGeometry: true
        });

        try {
            // Remove existing graphics before adding new one
            view.graphics.removeAll();

            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [98, 252, 251, 0.5], // LightSkyBlue with 50% opacity
                        outline: {
                            color: [98, 252, 251],
                            width: 3.0
                        }
                    },
                    popupEnabled: true,
                    popupTemplate: {
                        title: "Property ID: {relation_id}",
                        content: [


                            {
                                type: "fields",
                                fieldInfos: [
                                    { fieldName: "gis_uniqueid", label: "Gis Unique ID" },
                                    { fieldName: "ownername", label: "Owner Name" },
                                    { fieldName: "mobileno", label: "Mobile No" },
                                    { fieldName: "e_nagarpalikaid", label: "E Nagarpalika ID" },
                                    { fieldName: "landusetype", label: "Landuse Type" },
                                ]
                            },
                            {
                                type: "media",
                                mediaInfos: [
                                    {
                                        title: "<b>Property Photo</b>",
                                        type: "image",
                                        caption: "Linked to Relation ID",
                                        value: {
                                            sourceURL:
                                                "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                        }
                                    }
                                ]
                            },
                            {
                                type: "text",
                                text: `
    <div style="max-height: 300px; overflow-y: auto;">
      <div style="margin-bottom: 10px;">
        <b></b><br>
        <img 
          src="" 
          alt="" 
          style="width: 000px; height: 600px; border: 1px solid #ccc; margin-top: 5px;" 
        /><br>
        <i>Linked to Relation ID: {relation_id}</i>
      </div>      
    </div>
  `
                            }]
                    }//poptype close

                });

                view.graphics.add(graphic);

                // Zoom to the selected feature
                await view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to property:", error);
        }
    };





    const downloadExcel = () => {
        const dataToExport = activeSelect === "total" ? paginatedAllData : filteredPropertyData;

        if (!dataToExport || dataToExport.length === 0) {
            return;
        }

        try {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const colWidths = Object.keys(dataToExport[0]).map(key => ({
                wch: Math.max(
                    key.toString().length,
                    ...dataToExport.map(row => row[key] ? row[key].toString().length : 0)
                )
            }));
            ws['!cols'] = colWidths;

            const wb = XLSX.utils.book_new();
            let sheetName = activeSelect === "total" ? "All Properties" : `${selectedType || "Filtered"} Properties`;
            XLSX.utils.book_append_sheet(wb, ws, sheetName.substring(0, 30));

            let fileName = `Property_Data_${selectedTown || "All"}_${selectedLandUse || "All"}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            fileName = fileName.replace(/[^a-zA-Z0-9_\-\.]/g, "_");

            XLSX.writeFile(wb, fileName);

        } catch (error) {
            console.error("Error exporting to Excel:", error);
            alert("Error exporting data. Please try again.");
        }
    };

    // BHUPEN_LOAD
    useEffect(() => {

        fetchScadaData(null, null, null);
        const handleResize = () => {
            setIsScreenSize1(window.innerWidth <= 991)
        };
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    // BHUPEN_LOAD
    const handleToggleBufferWidth = () => {
        dispatch(setIsBufferWidth(!isBufferWidth));
    };
    const handleToggleBufferLeft = () => {
        dispatch(setIsSidebar(!isSideBar));
    };


    const calculatedHeight = useMemo(() => {
        const hasFeatureTableData = setFeatureTable?.length > 0;
        if (isWidth && isByDefaultActive) {
            return "calc(100vh - 78px)"; // Adjust height as needed
        }


        if (isWidth) {
            return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
        }
        if (isWidth) {
            return "calc(100vh - 78px)"
        }
        if (!isWidth && hasFeatureTableData) {
            return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
        }
        if (!isWidth && hasFeatureTableData && isByDefaultActive) {
            return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
        }
        if (!isToolHeight && isTableView) {
            return "calc(100vh - 322px)"
        }

        if (isToolHeight && isTableView) {
            return "calc(100vh - 360px)"
        }

        if (!isToolHeight) {
            return "calc(100vh - 210px)"
        }
        return "calc(100vh - 109px)";
    }, [isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight, isTableView]);


    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };


    // BHUPEN_D
    useEffect(() => {
        const loadDistricts = async () => {
            const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson`;

            //alert(url);
            try {
                const response = await fetch(url);
                const data = await response.json();

                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const userDistrict = [{
                        districtName: authData.DistrictName,
                        districtCode: authData.DistrictCode,
                    }];
                    setDistricts(userDistrict);
                    setDistrictCode(authData.DistrictCode);
                    setSelectedDistrict(authData.DistrictName);
                    await loadUlbs(authData.DistrictCode);
                } else {
                    const formatted = data.features.map(f => ({
                        districtName: f.properties.districtname,
                        districtCode: f.properties.dist_cd,
                    }));
                    setDistricts(formatted);
                }
            } catch (err) {
                console.error("Error loading districts:", err);
            }
        };


        if (!view) return;

        handleTabClick(ulbCode, districtCode);
        handleTabClickForFeature(ulbCode, districtCode);
        //BHUPEN_TBL
        // fetchScadaData(null, null, null);
        //BHUPEN_TBL

        if (selectedUlb && ulbCode) {
            zoomToUlb(selectedUlb);
            handleTabClick(ulbCode, null, districtCode);
            //  fetchScadaData(districtCode, ulbCode, null);
        } else if (selectedDistrict && districtCode) {
            zoomToDistrict(selectedDistrict);
            //  handleQuerySubmit(ulbCode, wardCode, districtCode);
            handleTabClick(null, null, districtCode);
            fetchScadaData(districtCode, null, null);

        }

        loadDistricts();
    }, [selectedDistrict, selectedUlb, districtCode, ulbCode, authData, view]);

    // BHUPEN_TBL LIVE
    // CODE FOR  TABLE LiveDATA API CALL
    const [noData, setNoData] = useState(false);
    const fetchScadaData = async (districtCode, ulbCode, siteId) => {
        try {
            setLoading(true);

            const response = await fetch(
                "https://urbangis.mp.gov.in/api/Station_Data/GetScadaDataSitewise",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        distCd: districtCode,
                        ulbCd: ulbCode,
                        siteId: siteId,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch data");
            }

            const res = await response.json();

            // ✅ Handle No Data Found case
            if (res.statusCode === 404 || !res.data) {
                console.warn(res.message || "No Data Found");
                setNoData(true);
                setLiveData([]);          // clear table
                // clear filtered data if used
                return;
            }

            // ✅ If data exists
            if (res.statusCode === 200 && Array.isArray(res.data)) {
                setLiveData(res.data);
                setIsTableView(true);
                setNoData(false);

            } else {
                // fallback if API returns different structure
                const data = res.data || [];
                setLiveData(data);

            }

        } catch (error) {
            console.error("Error fetching SCADA data:", error);
            setLiveData([]);

        } finally {
            setLoading(false);
        }
    };
    // CODE FOR TODAY DATE 
    const isToday = (date) => {
        const d = new Date(date);
        const today = new Date();
        return (
            d.getDate() === today.getDate() &&
            d.getMonth() === today.getMonth() &&
            d.getFullYear() === today.getFullYear()
        );
    };

    // CODE FOR TODSY DATE 
    // BHUPEN_TBL
    // BHUPEN_LOAD_DATA LIVE




    const handleDistrictChange = async (selectedOption) => {
        if (!selectedOption) {
            handleRefresh();
            return;
        }
        const district = districts.find(d => d.districtCode === selectedOption.value);
        if (district) {
            setDistrictCode(district.districtCode);
            setSelectedDistrict(district.districtName);
            setUlbCode(""); setSelectedUlb("");
            // setWardCode(""); setSelectedWard("");
            //BHUPEN_ULB
            await loadUlbs(district.districtCode);
            fetchScadaData(district.districtCode, null, null);

        }
    };
    // BHUPEN_D
    // BHUPEN_ULB
    const handleUlbChange = async (selectedOption) => {
        if (!selectedOption) {
            setUlbCode(""); setSelectedUlb("");
            return;
        }
        const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
        if (ulb) {
            setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName);
            fetchScadaData(null, ulb.ulbCode, null);

        }
    };

    // BHUPEN_ULB

    // BHUPEN_R CODE 
    const handleRefresh = async () => {
        // Reset Map
        view.graphics.removeAll(); // Clear any highlights

        // Go to the initial extent or center
        view.goTo({
            center: [77.4126, 23.2599],
            zoom: 6,
            ui: { components: ["attribution"] }
        });

        // Reset all filter states
        setSelectedDistrict("");
        setDistrictCode("");
        // setSelectedUlb("");
        // setUlbCode("");
        // setSelectedWard("");
        // setWardCode("");
        // setTableData("");
        //setTableData2("");

        // Reset dropdown options
        // setUlbs([]);
        // setWards([]);

        // // Dispatch reset actions
        // dispatch(setIsDist(""));
        // dispatch(setIsUlb(""));
        // dispatch(setIsWard(""));


        // Reset the map view to initial state

    };
    // BHUPEN_ULB

    const loadUlbs = async (dist_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/94/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=ulbname,ulb_cd&returnDistinctValues=true&f=geojson`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            // 🔹 If logged-in user is normal User → auto ULB
            if (authData?.UserType === "User") {
                const formattedUlbs = [{
                    ulbName: authData?.UlbName,
                    ulbCode: authData?.Ulb_Code,
                }];

                setUlbs(formattedUlbs);

                // auto select
                setUlbCode(authData?.Ulb_Code);
                setSelectedUlb(authData?.UlbName);

                // await loadWards(authData?.Ulb_Code);
                //zoomToFeatureTow(authData?.UlbName, "name", "5");
            }
            // 🔹 District / Admin users
            else if (data?.features) {
                const formattedUlbs = data.features.map(f => ({
                    ulbName: f.properties.ulbname,
                    ulbCode: f.properties.ulb_cd,
                }));

                setUlbs(formattedUlbs);
            }

        } catch (error) {
            console.error("Error fetching ULBs:", error);
        }
    };
    // BHUPEN_ULB

    // BHUPEN_D_ULB
    const zoomToDistrict = async (districtName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
        const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to district:", error);
        }
    };
    const zoomToUlb = async (ulbName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/94')}` });
        const query = new Query({ where: `ulbname = '${ulbName}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to ULB:", error);
        }
    };
    // BHUPEN_D_ULB


    // BHUPEN_ROW  SELECTED CODE 
    const navigate = useNavigate();
    const handleRowClick = (row) => {

        //navigate("/scada");  
        // alert(row.siteid);   
        //    navigate("/scada?siteid='"+row.siteid+"'", { state: { rowData: row } });
        navigate(`/scada?siteid=${row.siteid}`, {
            state: { rowData: row }
        });


    };
    // BHUPEN_ROW  SELECTED CODE 
    //BHUPEN_CSS FOR TABLE BOTTOM LAYOUT
    const thStyle = {
        border: "1px solid #ccc",
        padding: "10px",
        backgroundColor: "#09564e",
        color: "white",
        textAlign: "center",

        fontSize: "14px",
    };
    const tdStyleTD = {
        border: "1px solid #ccc",
        padding: "8px",
        textAlign: "center",
    };
    const styles = {
        container: {
            width: "100%",
            background: "#ffffff",

            borderRadius: "8px",
            border: "1px solid black",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            overflow: "auto"
        },
        heading: {
            marginBottom: "10px",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333"
        },
        loading: {
            color: "#666",
            fontSize: "14px"
        },
        tableWrapper: {
            maxHeight: "200px",
            overflowY: "auto",
            overflowX: "auto",
            border: "1px solid #ddd",
            borderRadius: "6px"
        },

        table: {
            width: "100%",
            height: "200px",
            borderCollapse: "collapse",
            fontFamily: "Arial, sans-serif"
        },
        th: {
            border: "1px solid #333",
            padding: "8px",
            textAlign: "center",
            backgroundColor: "#f2f2f2",
            fontWeight: "bold"
        },
        td: {
            border: "1px solid #333",
            padding: "8px",
            textAlign: "center"
        },
        evenRow: {
            backgroundColor: "#fafafa"
        },
        hoverRow: {
            backgroundColor: "#e6f2ff"
        }


    };
    const cardHeader = {
        background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
        borderRadius: "4px", overflow: "auto",
        fontSize: "18px",
        fontWeight: "700",
        textAlign: "center",
        marginBottom: "14px",
        color: "#333"
    };
    const countBox = {
        textAlign: "center",
        padding: "10px",
        background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
        borderRadius: "4px", overflow: "auto",

        border: "1px solid #aaa",
        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)"
    };

    const countValue = {
        fontSize: "26px",
        fontWeight: "700",
        color: "#000"
    };
    //BHUPEN_CSS FOR TABLE BOTTOM LAYOUT

    return (
        <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }} className='px-2 scada-home-layout'>
            {!isTableMaximized && (
                <div className='row scada-home-row'>
                    <div className={isBufferWidth ? 'col-md-12 p-0 h-100' : "col-md-9 p-0 h-100"}>

                        <div className="scada-home-main">
                            <div className={isTableMaximized ? "col-md-12" : "col-md-12"}>
                                <div className="position-relative scada-home-map-and-table">
                                    <div ref={mapDiv} className="scada-home-map"
                                        style={{
                                            width: "100%",
                                            height: calculatedHeight,
                                            borderRadius: "4px"
                                        }}>
                                    </div>

                                    {currentStageValue === 0 ? "" :
                                        <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
                                            <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
                                                <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                                            </div>
                                        </div>
                                    }
                                    {currentStageValue === 0 ? "" :
                                        <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
                                        >
                                            <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
                                                <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                                            </div>
                                        </div>
                                    }
                                    <center>
                                        {noData && (
                                            <table>
                                                <tr>
                                                    <td colSpan={14} style={{ textAlign: "center", color: "red", padding: "15px" }}>
                                                        <b> No Data Found </b>
                                                    </td>
                                                </tr>
                                            </table>
                                        )}
                                    </center>
                                    <div className="d-flex justify-content-between align-items-center scada-home-table">
                                        {/* //BHUPEN_TBL */}
                                        <div style={{ borderRadius: "4px", marginLeft: "10px", }}>
                                            <div style={styles.container}>
                                                {loading && <p style={styles.loading}>Loading...</p>}
                                                <div id="pdfTable" style={{ overflow: "auto" }}>
                                                    {LiveData && LiveData.length > 0 ? (
                                                        <div>
                                                            <div className="field"
                                                                style={{
                                                                    float: "right",
                                                                    marginTop: "5px",
                                                                    borderRadius: "4px",
                                                                }}>
                                                                <button className="details-btn"
                                                                    onClick={() => navigate("/SCADALive")} >
                                                                    More Details.....
                                                                </button>
                                                            </div>
                                                            {/* Header */}
                                                            <div
                                                                style={{
                                                                    background:
                                                                        "linear-gradient(90deg, #0f9239, #2658b6)",
                                                                    padding: "10px",
                                                                    textAlign: "center", color: "Yellow",
                                                                }}>
                                                                <b>Total STP INLET / OUTLET Device :{LiveData.length}</b>
                                                            </div>
                                                            <div
                                                                className="sacda-table"
                                                                style={{
                                                                    width: "100%",
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto",
                                                                }}>
                                                                <table
                                                                    style={{
                                                                        width: "100%",
                                                                        borderCollapse: "collapse",
                                                                    }}
                                                                >
                                                                    <thead
                                                                        style={{
                                                                            position: "sticky",
                                                                            top: 0,
                                                                            backgroundColor: "#f2f2f2",
                                                                            zIndex: 1,
                                                                        }}
                                                                    >
                                                                        <tr>
                                                                            <th style={thStyle}>S.No</th>
                                                                            <th style={thStyle}>ULB Name</th>
                                                                            <th style={thStyle}>Site ID</th>
                                                                            <th style={thStyle}>Device Name</th>
                                                                            <th style={thStyle}>Station</th>
                                                                            <th style={thStyle}>BOD (mg/L)</th>
                                                                            <th style={thStyle}>COD (mg/L)</th>
                                                                            <th style={thStyle}>TSS (mg/L)</th>
                                                                            <th style={thStyle}>pH</th>
                                                                            {/* <th style={thStyle}>Flow (m³/h)</th> */}
                                                                            <th style={thStyle}>TotalFlow  (MLD)</th>
                                                                            <th style={thStyle}>Status</th>
                                                                            <th style={thStyle}>Last data received</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {LiveData.map((item, index) => (
                                                                            <tr
                                                                                key={index}
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        item.siteId % 2 === 0
                                                                                            ? "#0d1b2a"
                                                                                            : "#222a33",
                                                                                    color: "#ffffff",
                                                                                }}
                                                                            >
                                                                                <td style={tdStyleTD}>{index + 1}</td>
                                                                                <td style={tdStyleTD}>{item.ulB_Name}</td>
                                                                                <td style={tdStyleTD}>{item.siteId}</td>
                                                                                <td style={tdStyleTD}>{item.deviceName}</td>
                                                                                <td style={tdStyleTD}>{item.stationName}</td>

                                                                                {/* BOD */}
                                                                                <td
                                                                                    style={tdStyleTD}
                                                                                    className={
                                                                                        item.stationName === "STP_OUTLET" &&
                                                                                            item.bod > 10
                                                                                            ? "blink-danger-text"
                                                                                            : "blink-danger-text_Narmal"
                                                                                    }
                                                                                >
                                                                                    {item.bod}
                                                                                </td>

                                                                                {/* COD */}
                                                                                <td
                                                                                    style={tdStyleTD}
                                                                                    className={
                                                                                        item.stationName === "STP_OUTLET" &&
                                                                                            item.cod > 50
                                                                                            ? "blink-danger-text"
                                                                                            : "blink-danger-text_Narmal"
                                                                                    }
                                                                                >
                                                                                    {item.cod}
                                                                                </td>

                                                                                {/* TSS */}
                                                                                <td
                                                                                    style={tdStyleTD}
                                                                                    className={
                                                                                        item.stationName === "STP_OUTLET" &&
                                                                                            item.tss > 10
                                                                                            ? "blink-danger-text"
                                                                                            : "blink-danger-text_Narmal"
                                                                                    }
                                                                                >
                                                                                    {item.tss}
                                                                                </td>
                                                                                {/* pH */}
                                                                                <td style={tdStyleTD}
                                                                                    className={
                                                                                        item.stationName === "STP_OUTLET" &&
                                                                                            item.ph > 9
                                                                                            ? "blink-danger-text"
                                                                                            : "blink-danger-text_Narmal"
                                                                                    }>
                                                                                    {item.ph}
                                                                                </td>
                                                                                {/* <td style={tdStyleTD}>{item.flow}</td> */}
                                                                                <td style={tdStyleTD}>
                                                                                    {item.flow_Total
                                                                                        ? (item.flow_Total / 1000).toFixed(2)
                                                                                        : "0.00"}
                                                                                </td>

                                                                                {/* Status */}
                                                                                <td
                                                                                    style={{
                                                                                        ...tdStyleTD,
                                                                                        fontWeight: "bold",
                                                                                        color:
                                                                                            (["STP_OUTLET", "STP_INLET"].includes(
                                                                                                item.stationName
                                                                                            ) &&
                                                                                                item.cod == null &&
                                                                                                item.bod == null &&
                                                                                                item.ph == null) ||
                                                                                                !isToday(item.recordDateTime)
                                                                                                ? "red"
                                                                                                : "#2ecc71",
                                                                                        animation:
                                                                                            (["STP_OUTLET", "STP_INLET"].includes(
                                                                                                item.stationName
                                                                                            ) &&
                                                                                                item.cod == null &&
                                                                                                item.bod == null &&
                                                                                                item.ph == null) ||
                                                                                                !isToday(item.recordDateTime)
                                                                                                ? "blinkText 1s infinite"
                                                                                                : "none",
                                                                                    }}
                                                                                >
                                                                                    {(["STP_OUTLET", "STP_INLET"].includes(
                                                                                        item.stationName
                                                                                    ) &&
                                                                                        item.cod == null &&
                                                                                        item.bod == null &&
                                                                                        item.ph == null) ||
                                                                                        !isToday(item.recordDateTime)
                                                                                        ? "Offline"
                                                                                        : "Live"}
                                                                                </td>

                                                                                <td style={tdStyleTD}>
                                                                                    <center>
                                                                                        {item.recordDateTime?.replace(
                                                                                            "T",
                                                                                            " "
                                                                                        )}
                                                                                    </center>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                padding: "10px",
                                                                textAlign: "center",
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>

                    </div>
                    {!isBufferWidth && (
                        <div className='col-md-3 p-0 h-100'>
                            <div className='px-2 h-100 d-flex flex-column scada-home-panel'>
                                <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                                    <h6 className='sidebarbuttontitle text-white m-0'>
                                        SCADA (Supervisory Control And Data Acquisition)
                                    </h6>

                                </div>

                                {/* <div className='scroll-layerdiv flex-grow-1' style={{ overflowY: 'auto' }}> */}
                                <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '} style={{
                                    background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
                                    borderRadius: "4px", overflow: "auto",
                                }}>
                                    <div>
                                        <h5 className="sidebarbuttontitle mt-3 mb-1 text-black">
                                            Select District </h5>
                                        {/* BHUPEN_D RIGHT  CODE FOR */}
                                        <Select
                                            options={districts.map((d) => ({ value: d.districtCode, label: d.districtName })).sort((a, b) => a.label.localeCompare(b.label))}
                                            value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                                            onChange={(selectedOption) => !selectedOption ? handleRefresh() : handleDistrictChange(selectedOption)}
                                            styles={customStyles} placeholder="Select District" isClearable={true} className="mt-3"
                                            isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                                        />

                                    </div>

                                    <div>
                                        <h5 className="sidebarbuttontitle mt-3 mb-1 text-black">
                                            Select Town  </h5>
                                        <Select
                                            options={ulbs.map((u) => ({ value: u.ulbCode, label: u.ulbName })).sort((a, b) => a.label.localeCompare(b.label))}
                                            value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                                            onChange={handleUlbChange} placeholder="Select ULB" isClearable={true}
                                            isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode} className="mt-3" styles={customStyles}
                                        />

                                    </div>

                                    <div style={{ backgroundColor: "gray" }}>
                                        {/* ===== CODE FOR DETAILS DATA ===== */}
                                        <div style={countBox}>
                                            <div style={cardHeader}>Total SCADA Installed</div>
                                            <div style={countValue}>{totalCount}</div>
                                        </div>

                                        {/* ===== DIVIDER ===== */}
                                        <div
                                            style={{
                                                backgroundColor: "#066853ff",
                                                color: "white",
                                                height: "10px",
                                            }}
                                        ></div>

                                        {/* ===== SEWERAGE TOGGLE ===== */}
                                        <label className="toggle-container">
                                            <input
                                                type="checkbox"
                                                checked={activeLayer === "sewer"}
                                            // onChange={() => handleToggle("sewer")}
                                            />
                                            <span className="toggle-switch"></span>
                                            <span className="toggle-label">SEWERAGE</span>
                                        </label>

                                        {/* BHUPEN_LIST DEVICE ===== SCADA DEVICE LIST SECTION ===== */}
                                        <div
                                            style={{
                                                height: "auto",
                                                minHeight: "20px",
                                                backgroundColor: "rgb(6, 99, 104)",
                                                color: "white",
                                                display: "flex",
                                                flexDirection: "column",
                                                overflowY: "auto",
                                            }}
                                        >
                                            {/* ===== CARD HEADER ===== */}
                                            <div style={cardHeader}>List of SCADA Device</div>

                                            {/* ===== DEVICE CARDS ===== */}
                                            {distictList.map((row, index) => (
                                                <div
                                                    key={row.siteid}
                                                    className={`data-card ${index % 2 === 0 ? "card-blue" : "card-purple"
                                                        }`}
                                                    onClick={() => handleRowClick(row)}
                                                >
                                                    <div className="card-top">
                                                        {/* ===== LEFT SIDE ===== */}
                                                        <div>
                                                            <div className="field">
                                                                <span className="label">Site ID :</span>
                                                                <span className="value">{row.siteid}</span>
                                                            </div>

                                                            <div className="field">
                                                                <button className="details-btn">
                                                                    View Details
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* ===== RIGHT SIDE ===== */}
                                                        <div>
                                                            <div className="field">
                                                                <span className="label">Site Name :</span>
                                                                <span className="value">{row.site_name}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* <button className="btn-refresh2" onClick={handleReset} style={{ marginTop: "14px" }}>
                                        <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"} alt="refresh" width="20px" height="20px" /> Refresh
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {isTableView && (
                <div className="bg-white border-top" >
                    {/* <div className="d-flex justify-content-between align-items-center py-1">
                        <div className="tabs-container">
                            <button className={`tab-btn ${activeSelect === "total" ? "active" : ""}`} onClick={() => setActiveSelect("total")}>Total Properties</button>
                            {selectedType && (
                                <button className={`tab-btn ${activeSelect === "filter" ? "active" : ""}`} onClick={() => setActiveSelect("filter")} >{selectedType} Properties</button>
                            )}
                        </div>

                        <div className="d-flex gap-2">

                            <button className='gradient-btn' onClick={downloadExcel}><img src="img/gradiant-download.svg" alt='download' /> Download Data</button>

                            <button
                                className="btn p-0 btn-titles btn-titlesdiv"
                                onClick={toggleTableMaximize}
                            >
                                {isTableMaximized ? (
                                    <>
                                        <img src="img/expand-icon.svg" alt='Maximise Panel' /> Minimize
                                    </>
                                ) : (
                                    <>
                                        <img src="img/expand-icon.svg" alt='Maximise Panel' /> Maximize
                                    </>
                                )}
                            </button>
                        </div>
                    </div> */}

                    {/* //BHUPEN_TBL */}

                </div>
            )}
        </div>
    );
}

export default SCADAHome;
